import { createFileRoute, notFound, Outlet } from "@tanstack/react-router"
import { GatedSessionDetailsFailReason } from "ipctg-inflow-types/InFlowEnums"

import { NOT_FOUND_SESSION } from "@/globalComponents/organisms/RootNotFound"
import { Route as QrQrLookupIDGatedPamIDLookUpChallengeImport } from "@/routes/qr/$qrLookupID/gated/$pamID/look-up.challenge"
import { Route as QrQrLookupIDGatedPamIDLookUpIndexImport } from "@/routes/qr/$qrLookupID/gated/$pamID/look-up.index"
import { ExpectedError } from "@/utilities/expectedErrors"
import { sessionDetailsQueryOptions } from "@/utilities/hooks/queries/express"
import { fetchWelcomeToken } from "@/utilities/hooks/queries/shared"

export const Route = createFileRoute("/qr/$qrLookupID/gated/$pamID/$sessionID")(
  {
    beforeLoad: async ({ context, params, matches }) => {
      const cartPageMatch = matches.find(
        (m) => m.routeId === "/qr/$qrLookupID/gated/$pamID/$sessionID/cart"
      )

      if (
        cartPageMatch &&
        ![
          QrQrLookupIDGatedPamIDLookUpIndexImport.id,
          QrQrLookupIDGatedPamIDLookUpChallengeImport.id,
        ].some((id) => id === cartPageMatch.search.from)
      ) {
        context.queryClient.clear()
        await fetchWelcomeToken({ qrLookupID: params.qrLookupID })
      }

      try {
        await context.queryClient.fetchQuery(
          sessionDetailsQueryOptions({ sessionID: params.sessionID })
        )
      } catch (error) {
        if (
          error instanceof ExpectedError &&
          error.failReason === GatedSessionDetailsFailReason.SessionNotFound
        ) {
          throw notFound({
            data: {
              type: NOT_FOUND_SESSION,
            },
          })
        }
        throw error
      }
    },
    shouldReload: true,
    component: Outlet,
  }
)
